module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "western",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "c1"
  }, [_vm._v("The Journal")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "c2"
  }, [_vm._v("Crimson Skies")]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "c1"
  }, [_vm._v("By Deborah D. Moore")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0e6f04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue
// module id = 63
// module chunks = 0